export default __webpack_public_path__ + "flutter.bd80d58c.png";